import request from "@/router/axios";

//列表查询
export const getList = (params) => {
    return request({
        url: "/api/produce/accident-info/select/page",
        method: "post",
        params: params,
    });
};
export const exportExcel = (params) => {
    return request({
        url: "/api/produce/accident-info/export/excel",
        method: "post",
        data: params,
        responseType: "blob",
    });
};

//新增
export const add = (row) => {
    return request({
        url: "/api/produce/accident-info/insert",
        method: "post",
        data: row,
    });
};

//更新
export const update = (row) => {
    return request({
        url: "/api/produce/accident-info/update",
        method: "post",
        data: row,
    });
};

// 删除
export const remove = (id) => {
    return request({
        url: "/api/produce/accident-info/delete/id",
        method: "post",
        params: { id: id },
    });
};

//详情
export const getDetail = (id) => {
    return request({
        url: "/api/produce/accident-info/select/id",
        method: "get",
        params: { id },
    });
};

// Accident report image upload
export const uploadEndpoint = "/api/produce/accident-info/upload-image";
